import { useContext } from "react";
import { useState } from "react";
import { createContext } from "react"
import { Modal } from "../componentes/layout/modal/Modal";

const ModalContext = createContext({})

export function ModalProvider({children}) {
    const [modal, setModal] = useState({})

    function abrirModal(modal) {
      setModal(modal)
      document.getElementById("abrirModal").click()
    }

    function limparModal(){
      const timer = setTimeout(() => {
        if(!document.getElementById('modal-default').getAttribute('aria-hidden')){
          document.getElementById("btnFecharModal").click()
        }
        setModal({})
        clearTimeout(timer)
      }, 100);
    }

    return (
      <ModalContext.Provider value={{ modal, abrirModal, limparModal }}>
        {children}
        <Modal />
      </ModalContext.Provider>
    )
}

export function useModal() {
    const context = useContext(ModalContext)

    return context;
}